// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2lnpD","inner":"Footer_inner__2UKK7","nextIcon":"Footer_nextIcon__3Ru4V","innerLeft":"Footer_innerLeft__3l-Pi"};